import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// const firebaseConfig = {
//   apiKey: "AIzaSyD7us7Do4SJkk8FnQpozlUzEGvifScvvTA",
//   authDomain: "fooddistribution-ecb06.firebaseapp.com",
//   projectId: "fooddistribution-ecb06",
//   storageBucket: "fooddistribution-ecb06.appspot.com",
//   messagingSenderId: "1060861034608",
//   appId: "1:1060861034608:web:2565bfae80987ca80ab4b5",
//   measurementId: "G-ZN4GZVJN5H"
// };
const firebaseConfig = {
  apiKey: "AIzaSyCuodsDiEcbc0nIDGyVmR92UDItE60RCYs",
  authDomain: "gppfooddata.firebaseapp.com",
  databaseURL: "https://gppfooddata-default-rtdb.firebaseio.com",
  projectId: "gppfooddata",
  storageBucket: "gppfooddata.appspot.com",
  messagingSenderId: "841876351807",
  appId: "1:841876351807:web:8a2bb05526e776be7e818a",
  measurementId: "G-H0DYCPL130"
};

// // Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth();
export const storage = getStorage();
export const db = getFirestore(app)


// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";

// const firebaseConfig = {
//   apiKey: "AIzaSyCuodsDiEcbc0nIDGyVmR92UDItE60RCYs",
//   authDomain: "gppfooddata.firebaseapp.com",
//   databaseURL: "https://gppfooddata-default-rtdb.firebaseio.com",
//   projectId: "gppfooddata",
//   storageBucket: "gppfooddata.appspot.com",
//   messagingSenderId: "841876351807",
//   appId: "1:841876351807:web:4ae8d99ec2aa20ef7e818a",
//   measurementId: "G-5Q09D2YLTJ"
// };

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
